/**
 * Shared slugify used by BOTH the article loaders (TOC ids) and the markdown
 * renderer (heading ids) so in-page anchors line up exactly. Consumed by the
 * docs site and the blog.
 *
 * Keep this implementation identical everywhere — do not fork it.
 */
export const slugify = (s: string): string =>
	s
		.toLowerCase()
		.trim()
		.replace(/[^a-z0-9]+/g, '-')
		.replace(/(^-|-$)/g, '');
